import { ClientInferRequest, ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";

export type Batch = ClientInferRequest<typeof contract.quotes.create>["body"]["batches"][number];

type CreateQuoteDto = ClientInferRequest<typeof contract.quotes.create>["body"];

export type Quote = ClientInferResponseBody<typeof contract.quotes.create, 201>;

export const createQuote = async (quote: CreateQuoteDto): Promise<Quote | null> => {
  const response = await api.quotes.create.mutation({
    body: { ...quote },
    timeout: 30000,
  });

  if (response.status === 201) {
    return response.body;
  }

  return null;
};
